import { Injectable } from '@angular/core';
import { MixpanelService } from 'src/core/services/mixpanel.service';

export const enum TrackingOrderType {
  Limit = 'Limit',
  Market = 'Market',
  MPLActive = 'Active',
  MPLPassive = 'Passive',
  MPLHiddenVolume = 'Active volume',
  OneCancelsAnother = 'OCA',
  OneTriggersAnother = 'OTA',
  InLineStop = 'Stop loss',
  LimitedStop = 'Stop limit',
  TrailingStop = 'Trailing stop',
  ShortSelling = 'Short selling',
}

export const enum TrackingTransactionType {
  Buy = 'Buy',
  Sell = 'Sell',
  Withdrawal = 'Withdrawal',
}

export const enum TrackingOrigin {
  Portfolio = 'Portfolio',
  Market = 'Market',
  FollowedAssets = 'Followed assets',
  Opportunities = 'Opportunities',
  Intraday = 'Intraday',
  HistoricalData = 'Historical data',
  Funds = 'Funds',
}

export const enum TrackingIssuerType {
  Capital = 'Capital',
  MutualFunds = 'Mutual Funds',
  Cash = 'Cash',
}

export const enum FundType {
  ft = 'Franklin Templeton',
  gbm = 'GBM',
}

export interface TrackingTradeInfo {
  'Issuer type': TrackingIssuerType;
  'Transaction type': TrackingTransactionType;
  Latitude?: string;
  Longitude?: string;
  Origin: TrackingOrigin;
  'Order type'?: TrackingOrderType;
  'Mutual Funds'?: 'true' | 'false';
  Amount?: string;
  Issuer?: string;
  Price?: string;
  Quantity?: string;
  Success?: 'true' | 'false';
  Callback?: 'Success' | string;
  Type: 'Trading';
  'Fund type'?: FundType;
}
@Injectable()
export class AnalyticsTrackingService {
  constructor(private mixpanel?: MixpanelService) {}

  logEvent(event: any, properties?: any) {
    this.mixpanel.track(event, properties);
  }

  processTransactionType(transactionType: string): TrackingTransactionType {
    const availableTransactions: any = {
      compra: TrackingTransactionType.Buy,
      venta: TrackingTransactionType.Sell,
      retiro: TrackingTransactionType.Withdrawal,
    };

    if (availableTransactions[transactionType]) {
      return availableTransactions[transactionType];
    }

    throw new Error('Tracking: Undefined Transaction Type');
  }

  processOrigin(origin: string): TrackingOrigin {
    const paths: any = {
      '/main/portfolio': TrackingOrigin.Portfolio,
      '/main/mercados': TrackingOrigin.Market,
      '/main/analisis/tech-rules': TrackingOrigin.FollowedAssets,
      '/main/analisis/purchaseOpportunities': TrackingOrigin.Opportunities,
      '/main/ordenes': TrackingOrigin.Intraday,
      '/main/ordenes/historial': TrackingOrigin.HistoricalData,
      '/main/funds': TrackingOrigin.Funds,
    };

    if (paths[origin]) {
      return paths[origin];
    }

    throw new Error('Tracking: Undefined Origin Type');
  }
}
